export const initAccordions = () => {
  const accordions = document.querySelectorAll('.materials__accordion');

  accordions.forEach((acc) => {
    const header = acc.querySelector('.materials__accordion-header');
    const panel = acc.querySelector('.materials__accordion-panel');
    if (!header || !panel) return;

    const setOpen = (open) => {
      acc.classList.toggle('is-open', open);
      header.setAttribute('aria-expanded', String(open));
      panel.style.maxHeight = open ? `${panel.scrollHeight}px` : '0px';
    };

    setOpen(acc.classList.contains('is-open'));

    header.addEventListener('click', () => {
      setOpen(!acc.classList.contains('is-open'));
    });

    window.addEventListener('resize', () => {
      if (acc.classList.contains('is-open')) {
        panel.style.maxHeight = `${panel.scrollHeight}px`;
      }
    });
  });
};
